// create a react hook to get and save a value from local storage

import { useState } from "react";

//
export const useLocalStorage = (key: string, initialValue: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value: any) => {
    window.localStorage.setItem(key, JSON.stringify(value));
    setStoredValue(value);
  };

  const removeValue = () => {
    window.localStorage.removeItem(key);
    setStoredValue(null);
  };
  return { value: storedValue, setValue, removeValue };
};

export const useSessionStorage = (key: string, initialValue: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value: any) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
    setStoredValue(value);
  };

  const removeValue = () => {
    window.sessionStorage.removeItem(key);
    setStoredValue(null);
  };
  return { value: storedValue, setValue, removeValue };
};

export const useSessionStorageObject = (key: string, initialValue: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (_key: string, value: any) => {
    const item = { ...storedValue, [_key]: value };
    window.sessionStorage.setItem(key, JSON.stringify(item));
    setStoredValue(item);
  };

  const removeValue = () => {
    window.sessionStorage.removeItem(key);
    setStoredValue(null);
  };
  return { value: storedValue, setValue, removeValue };
};
